import { Component, Input, OnInit } from '@angular/core';
import { benchmarkData, ProductBenchmarkRequest } from '../../components/product-benchmark/product-benchmark.component';
import { BenchmarkIconEnum } from '../../enums/benchmark-icon';
import { smallAnimation } from '../../animations/allAnimations';
import { ModuleName } from '../../enums/ModuleName';

@Component({
  selector: 'app-benchmark-template',
  templateUrl: './benchmark-template.component.html',
  styleUrls: ['./benchmark-template.component.scss'],
  animations: [smallAnimation]
})
export class BenchmarkTemplateComponent {
  @Input() benchmarkRequest: ProductBenchmarkRequest;
  @Input() benchmarkData: benchmarkData[];
  @Input() language: string;
  @Input() factor: string;
  @Input() isReport: boolean = false;
  BenchmarkIconEnum = BenchmarkIconEnum
  ModuleNames = ModuleName

  constructor() {
    setTimeout(() => {
      console.log('factor: ', this.factor);
      console.log('benchmarkData: ', this.benchmarkData);
      console.log('benchmarkRequest: ', this.benchmarkRequest);
      console.log('language: ', this.language);
      console.log('isReport: ', this.isReport);
    }, 1000);
  }

  logData(data: any) {
    console.log('data: ', data);
  }
}
